<template>
  <div class="tab-item-cls">
    <div class="title">
      <!-- <span class="tab-img macro-tag"></span>
      <span class="item-title">Macro</span> -->
      <p class="pde" :title="detail">{{detail}}</p>
    </div>
    <el-row class="row-top">
      <el-col :span="12">
        <barLine :xData="xData1" :serData="serData1" :chartHeight="chartHeight"></barLine>
      </el-col>
      <el-col :span="12">
        <barLine :xData="xData2" :serData="serData2" :chartHeight="chartHeight"></barLine>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import barLine from "./barLine";
import color from "./color";
import { getMacroData } from "common/js/http/v2Api";
export default {
  props: {
    chartHeight: {
      type: Number
    }
  },

  components: {
    barLine
  },

  created() {
    console.log("macro create");
  },

  data() {
    return {
      xData1: [],
      serData1: [],
      xData2: [],
      serData2: [],
      detail:`It provides macro economic data of about 120 countries and regions worldwide. You can search by country, region and index name. Meanwhile, you can have access to China’s macroeconomic data information, such as finance, foreign trade, industrial enterprise data, population and resource environment, etc. `
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      const { result } = await getMacroData();
      const title = Object.keys(result);
      if (title[0]) {
        const converResult = this.convertData(
          result[title[0]].result.data[0],
          result[title[0]].result.columns
        );

        this.xData1 = converResult.xData;
        this.serData1 = converResult.serData;
      }

      if (title[1]) {
        const converResult = this.convertData(
          result[title[1]].result.data[0],
          result[title[1]].result.columns
        );

        this.xData2 = converResult.xData;
        this.serData2 = converResult.serData;
      }
    },

    convertData(data, column) {
      let xData = [];
      const unit = data.unit_cn_description;
      const i = Math.round(Math.random() * 10);
      let countryName = data.country_cn_simplename
        ? ":" + data.country_cn_simplename
        : "";
      const dataItem = Object.assign(this.getCommonConfig(i), {
        name: data.cn_name + countryName,
        data: [],
        unit
      });

      column.forEach(item => {
        if (item.isDate) {
          xData.push(item.field);
        }
      });
      xData = xData.sort(function(a, b) {
        return new Date(a).getTime() - new Date(b).getTime();
      });

      xData.forEach(item => {
        dataItem.data.push(data[item]);
      });

      // column.forEach(j => {
      //   if (j.isDate) {
      //     xData.push(j.field);
      //     dataItem.data.push(parseInt(data[j.field]) || 0);
      //   }
      // });
      return {
        xData,
        serData: [dataItem]
      };
    },

    getCommonConfig(index) {
      return {
        name: "",
        type: "bar",
        // stack: "dta",
        data: [],
        unit: "",
        barMinHeight: 5,
        smooth: true,
        itemStyle: {
          normal: {
            color: color[index % 10], //改变折线点的颜色
            lineStyle: {
              color: color[index % 10] //改变折线颜色
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.company-title {
  font-size: 12px;
  color: #000000;
  margin-top: 30px;
  font-weight: 600;
}
.row-top {
  margin-top: 49px;
}
</style>